import { html, PropertyValues, TemplateResult } from 'lit';
import { API_TYPE_NIRVANA, WEB_COMPONENT_EXECUTIVE_SUMMARY_INVENTORY } from '../../../../webcomponents.constants';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { customElement, property, query } from 'lit/decorators.js';
import { GetWidgetDataRequest } from '../../../../types/widget/types';
import { Observable, of } from 'rxjs';
import { GetInventoryInformationResponse, InventoryPayload } from '@nirvana/shared/dtos/types/widgets/common';
import { translateFn } from '../../../../utils/translator.helper';
import { getTimezone } from '../../../../utils/global.utils';
import { InventoryWebComponent } from '../../../../inventory';
import { getDisplayMode, sanitizeReportingPeriod } from '../../../utils/utils';

@customElement(WEB_COMPONENT_EXECUTIVE_SUMMARY_INVENTORY)
export class GzInventoryWebComponent extends GzGenericWidgetContent {
  @property({ type: Object, attribute: true, reflect: true })
  payload: InventoryPayload;

  @query('#gzInventory')
  private inventory: InventoryWebComponent;

  injectDependencies(dependencies: any) {
    this.dependencies = dependencies;
  }

  getPayload() {
    return this.payload;
  }

  updated(_changedProperties: PropertyValues): void {
    super.updated(_changedProperties);

    const dependencies = {
      Ext: this.dependencies ? this.dependencies.Ext : undefined,
      getTimezone: getTimezone,
      getUserLanguage: Application.Main.getLanguage,
      translateFn: translateFn,
      api: {
        type: API_TYPE_NIRVANA,
        clients: {
          Widgets: {
            getInventoryInformation: function (
              request: GetWidgetDataRequest
            ): Observable<GetInventoryInformationResponse> {
              return of(this.getPayload().inventoryInformation);
            }.bind(this),
          },
        },
      },
    };

    if (this.inventory) {
      if (!this.inventory.started) {
        this.inventory.injectDependencies(dependencies);
        this.inventory.start();
      } else {
        this.inventory.controller?.render();
      }
    }
  }

  protected renderContent(): TemplateResult {
    return html` <gz-inventory
      id="gzInventory"
      data-reporting-period=${JSON.stringify(sanitizeReportingPeriod(this.payload?.reportingPeriod))}
      data-targets=${JSON.stringify(this.payload?.targets)}
      data-can-drill-down=${true}
      data-display-mode=${getDisplayMode()}
    ></gz-inventory>`;
  }
  protected renderLoader(): TemplateResult {
    return html`<gz-loader rows="${this.loadingRows}" columns="${this.loadingColumns}"></gz-loader>`;
  }
}
